import {ethers} from 'ethers'
import { jsonRpcUrlMap, networkToChainId } from '../constants/EIP1193';
import { getGCPermitRonin } from './gcPermitServiceRonin';
let permitTokenContract = '0xF0075b06b4229C20B7c22b7E63D90723b3551861';
let handlerContract = '0x7847e293421be1E2e8016ca3bB81Ea2acF4D1dd1';


let permitAbi = [
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "nonces",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

async function getPermitSignature(wallet:any, token:any, spender:any, value:any, deadline:any) {
    const [nonce, name, version, chainId] = await Promise.all([
        token.nonces(wallet.address),
        token.name(),
        '1',
        wallet.getChainId(),
    ])
    console.log('nonce', nonce)
    console.log('name', name)
    console.log('version', version)
    console.log('chainId', chainId)
    console.log(value)
    try {
        const hashedStruct = ethers.utils._TypedDataEncoder.hash({
            name: name,
            version: version,
            chainId: chainId,
            verifyingContract: token.address,
        },
                                                                 {
            Permit: [
                {
                    name: 'owner',
                    type: 'address',
                },
                {
                    name: 'spender',
                    type: 'address',
                },
                {
                    name: 'value',
                    type: 'uint256',
                },
                {
                    name: 'nonce',
                    type: 'uint256',
                },
                {
                    name: 'deadline',
                    type: 'uint256',
                },
            ],
        },
                                                                 {
            owner: wallet.address,
            spender,
            value,
            nonce,
            deadline,
        });

        let signingKey = new ethers.utils.SigningKey(wallet.privateKey)
        let sig = await signingKey.signDigest(hashedStruct)

        return ethers.utils.joinSignature({
            v: sig.v,
            r: sig.r,
            s: sig.s,
        })

    } catch (e) {
        console.log(e)
    }

    return null
}

export async function getGCPermit(amount:any) {
    const walletType = localStorage.getItem('gw-wallet-type');
    if (walletType === 'RoninWaypoint' || walletType === 'Glip') {
        return await getGCPermitRonin(amount, walletType);
    }
    try {
        let walletInfo:any = JSON.parse((localStorage.getItem('gw-wallet-info') as any))
        let userAddress:any = walletInfo.address
        console.log('walletInfo', walletInfo)
        let pk = walletInfo.privateKey
        let chainId = networkToChainId.get('matic') as number;
        // let url = jsonRpcUrlMap[chainId];
        let url = "https://polygon-mainnet.g.alchemy.com/v2/_tn9X7pFnXwYXYi8Q33gQjRg_B3Dey_4";
        let provider = new ethers.providers.JsonRpcProvider(url)

        const signer = new ethers.Wallet(pk, provider);

        let token = new ethers.Contract(permitTokenContract, permitAbi, signer)
        let deadline = ethers.constants.MaxUint256
        console.log('amount', amount)
        let signature = await getPermitSignature(signer, token, handlerContract, ethers.utils.parseEther(amount.toString()), deadline)
        console.log('signed permit', signature)
        return signature;
    } catch (e) {
        console.log(e)
        return null;
    }    
}


